import React, { useCallback, useState } from 'react';

import { useAppSelector } from '@pkg/hooks';

import './YatSidebar.scss';
import { YatSidebarList } from './YatSidebarList';

interface YatSidebarProps {
    expanded?: boolean;
    isPrimaryYatPicker?: boolean;
}

export function YatSidebar({ expanded = false, isPrimaryYatPicker = false }: YatSidebarProps) {
    const sidebar = useAppSelector((state) => state.dashboard.sidebar);
    const [isDragging, setIsDragging] = useState(false);
    const [sidebarIsExpanded, setSidebarIsExpanded] = useState(false);

    const onDragStateChange = useCallback((dragging: boolean) => setIsDragging(dragging), []);
    const isExpanded = expanded || sidebarIsExpanded || isDragging || sidebar.hasOpenSubGroup;
    const handleHover = useCallback(() => {
        if (expanded) return;
        setSidebarIsExpanded((c) => !c);
    }, [expanded]);
    return (
        <nav
            className={`yat-sidebar ${isExpanded ? 'yat-sidebar--is-expanded' : ''} ${
                sidebar.hasOpenSubGroup ? 'yat-sidebar--has-open-groups' : ''
            }`}
        >
            <div className="yat-sidebar__list" onMouseEnter={handleHover} onMouseLeave={handleHover}>
                <YatSidebarList isPrimaryYatPicker={isPrimaryYatPicker} onDragStateChange={onDragStateChange} />
            </div>
        </nav>
    );
}
